<app-header></app-header>
<app-menu></app-menu>

<div nxLayout="grid">
  <!-- Tabs -->
  <div nxRow class="nx-margin-left-2xl nx-margin-right-2xl">
    <div nxCol="12">
      <nx-tab-group (selectedTabChange)="onTabChange($event)">

        <!-- ═══════════════════════════════════════ Tab 1: Dealer Commission Dashboard -->
        <nx-tab label="Dealer Commission Dashboard">
          <div class="tab__content">

            <ng-container *ngIf="!stats">
              <div style="text-align:center; padding: 60px 0;">
                <nx-spinner nxSize="large"></nx-spinner>
                <p nxCopytext="normal" class="nx-margin-top-m">Loading dashboard...</p>
              </div>
            </ng-container>

            <ng-container *ngIf="stats">

              <!-- KPI STAT TILES -->
              <div nxRow class="nx-margin-top-m nx-margin-bottom-m">

                <div nxCol="6,4,2,2">
                  <div class="stat-tile total" (click)="navigateTo('All')">
                    <div class="stat-icon"><nx-icon name="product-paper-document" size="l"></nx-icon></div>
                    <div class="stat-count">{{ stats.totalInvoices }}</div>
                    <div class="stat-label">Total Invoices</div>
                  </div>
                </div>

                <div nxCol="6,4,2,2">
                  <div class="stat-tile under-process" (click)="navigateTo('Submitted')">
                    <div class="stat-icon"><nx-icon name="send" size="l"></nx-icon></div>
                    <div class="stat-count">{{ stats.submitted }}</div>
                    <div class="stat-label">Submitted</div>
                  </div>
                </div>

                <div nxCol="6,4,2,2">
                  <div class="stat-tile approved" (click)="navigateTo('Invoice Accepted')">
                    <div class="stat-icon"><nx-icon name="check-circle" size="l"></nx-icon></div>
                    <div class="stat-count">{{ stats.invoiceAccepted }}</div>
                    <div class="stat-label">Invoice Accepted</div>
                  </div>
                </div>

                <div nxCol="6,4,2,2">
                  <div class="stat-tile rejected" (click)="navigateTo('Invoice Rejected')">
                    <div class="stat-icon"><nx-icon name="close-circle" size="l"></nx-icon></div>
                    <div class="stat-count">{{ stats.invoiceRejected }}</div>
                    <div class="stat-label">Invoice Rejected</div>
                  </div>
                </div>

                <div nxCol="6,4,2,2">
                  <div class="stat-tile under-process" (click)="navigateTo('Invoice Under Process')">
                    <div class="stat-icon"><nx-icon name="in-progress" size="l"></nx-icon></div>
                    <div class="stat-count">{{ stats.invoiceUnderProcess }}</div>
                    <div class="stat-label">Invoice Under Process</div>
                  </div>
                </div>

                <div nxCol="6,4,2,2">
                  <div class="stat-tile paid" (click)="navigateTo('Invoice Paid')">
                    <div class="stat-icon"><nx-icon name="wallet" size="l"></nx-icon></div>
                    <div class="stat-count">{{ stats.invoicePaid }}</div>
                    <div class="stat-label">Invoice Paid</div>
                  </div>
                </div>
              </div>

              <!-- AMOUNT TILES (admin only) -->
              <div nxRow class="nx-margin-bottom-m" *ngIf="isAdminView">
                <div nxCol="12,6,3,3">
                  <div class="amount-tile">
                    <div class="amount-label">Total Claimed Amount</div>
                    <div class="amount-value">{{ stats.totalAmount | currency:'INR':'symbol':'1.0-0' }}</div>
                  </div>
                </div>
                <div nxCol="12,6,3,3">
                  <div class="amount-tile paid-amt">
                    <div class="amount-label">Total Paid Out</div>
                    <div class="amount-value">{{ stats.totalPaidAmount | currency:'INR':'symbol':'1.0-0' }}</div>
                  </div>
                </div>
                <div nxCol="12,6,3,3">
                  <div class="amount-tile pending-amt">
                    <div class="amount-label">Pending Payment</div>
                    <div class="amount-value">{{ (stats.totalAmount - stats.totalPaidAmount) | currency:'INR':'symbol':'1.0-0' }}</div>
                  </div>
                </div>
                <div nxCol="12,6,3,3">
                  <div class="amount-tile dealers-amt">
                    <div class="amount-label">Dealers with Open Invoices</div>
                    <div class="amount-value">{{ stats.dealersWithOpenInvoices }}</div>
                  </div>
                </div>
              </div>

              <!-- CHARTS ROW -->
              <div nxRow class="nx-margin-bottom-m">
                <div nxCol="12,12,6,6">
                  <nx-card class="chart-card">
                    <div class="card-header-row">
                      <h3 nxHeadline="subsection-small" class="nx-font-weight-semibold chart-title">
                        Invoice Status Distribution
                      </h3>
                      <nx-radio-toggle [nxStyle]="'small'" name="chartType" [(ngModel)]="chartType" (ngModelChange)="changeChartType($event)">
                        <nx-radio-toggle-button nxValue="1" [nxSelected]="true">
                          <nx-icon name="product-stock-data-graph"></nx-icon>
                        </nx-radio-toggle-button>
                        <nx-radio-toggle-button nxValue="2">
                          <nx-icon name="product-share-graph-arrow-up"></nx-icon>
                        </nx-radio-toggle-button>
                      </nx-radio-toggle>
                    </div>
                    <canvas id="commStatusChart" height="260"></canvas>
                    <p class="chart-hint">Click a bar to view filtered invoices</p>
                  </nx-card>
                </div>

                <div nxCol="12,12,6,6">
                  <nx-card class="chart-card">
                    <h3 nxHeadline="subsection-small" class="nx-font-weight-semibold chart-title">
                      Monthly Invoice Trend (Last 6 Months)
                    </h3>
                    <canvas id="commTrendChart" height="260"></canvas>
                  </nx-card>
                </div>
              </div>

            </ng-container>
          </div>
        </nx-tab>

        <!-- ═══════════════════════════════════════ Tab 2: Dealer Claims Dashboard -->
        <nx-tab label="Dealer Claims Dashboard">
          <div class="tab__content">

            <ng-container *ngIf="!claimStats">
              <div style="text-align:center; padding: 60px 0;">
                <nx-spinner nxSize="large"></nx-spinner>
                <p nxCopytext="normal" class="nx-margin-top-m">Loading claims...</p>
              </div>
            </ng-container>

            <ng-container *ngIf="claimStats">
              <div nxRow class="nx-margin-top-m nx-margin-bottom-m">
                <div nxCol="6,4,2,2">
                  <div class="stat-tile total" (click)="navigateToClaim(-1)">
                    <div class="stat-icon"><nx-icon name="product-paper-document" size="l"></nx-icon></div>
                    <div class="stat-count">{{ claimStats.total }}</div>
                    <div class="stat-label">Total Claims</div>
                  </div>
                </div>
                <div nxCol="6,4,2,2">
                  <div class="stat-tile pending" (click)="navigateToClaim(0)">
                    <div class="stat-icon"><nx-icon name="in-progress" size="l"></nx-icon></div>
                    <div class="stat-count">{{ claimStats.underProcess }}</div>
                    <div class="stat-label">Under Process</div>
                  </div>
                </div>
                <div nxCol="6,4,2,2">
                  <div class="stat-tile paid" (click)="navigateToClaim(1)">
                    <div class="stat-icon"><nx-icon name="wallet" size="l"></nx-icon></div>
                    <div class="stat-count">{{ claimStats.paid }}</div>
                    <div class="stat-label">Paid</div>
                  </div>
                </div>
                <div nxCol="6,4,2,2">
                  <div class="stat-tile rejected" (click)="navigateToClaim(2)">
                    <div class="stat-icon"><nx-icon name="close-circle" size="l"></nx-icon></div>
                    <div class="stat-count">{{ claimStats.rejected }}</div>
                    <div class="stat-label">Rejected</div>
                  </div>
                </div>
              </div>

              <div nxRow class="nx-margin-bottom-2m">
                <div nxCol="12,12,6,6">
                  <nx-card class="chart-card">
                    <h3 nxHeadline="subsection-small" class="nx-font-weight-semibold chart-title">
                      Claim Status Distribution
                    </h3>
                    <canvas id="claimStatusChart" height="260"></canvas>
                    <p class="chart-hint">Click a bar to view filtered claims</p>
                  </nx-card>
                </div>
              </div>
            </ng-container>

          </div>
        </nx-tab>

        <!-- ═══════════════════════════════════════ Tab 3: PFU Dashboard -->
        <nx-tab label="PFU Dashboard">
          <div class="tab__content">

            <ng-container *ngIf="!stats">
              <div style="text-align:center; padding: 60px 0;">
                <nx-spinner nxSize="large"></nx-spinner>
                <p nxCopytext="normal" class="nx-margin-top-m">Loading dashboard...</p>
              </div>
            </ng-container>

            <ng-container *ngIf="stats">

              <!-- OUTSTANDING PAYMENTS AGEING -->
              <div nxRow class="nx-margin-top-m nx-margin-bottom-m">
                <div nxCol="12">
                  <nx-card class="chart-card">
                    <h3 nxHeadline="subsection-small" class="nx-font-weight-semibold chart-title nx-margin-bottom-s">
                      Outstanding Payments — Ageing Buckets
                      <span class="ageing-hint">(Days outstanding — Pending &amp; Under Process invoices)</span>
                    </h3>
                    <div nxLayout="grid" class="ageing-grid">

                      <!-- < 30 days -->
                      <div nxRow>
                        <div nxCol="4,3,2,2" class="ageing-bucket-label">
                          <span class="ageing-dot ageing-fresh"></span> &lt; 30 days
                        </div>
                        <div nxCol="4,3,2,2" class="ageing-count ageing-fresh">
                          {{ stats.ageing?.underThirty ?? 0 }}
                        </div>
                        <div nxCol="4,6,8,8" class="ageing-bar-wrap">
                          <div class="ageing-bar ageing-bar-fresh"
                            [style.width.%]="stats.totalInvoices > 0 ? ((stats.ageing?.underThirty ?? 0) / stats.totalInvoices * 100) : 0">
                          </div>
                        </div>
                      </div>

                      <!-- 30–60 days -->
                      <div nxRow>
                        <div nxCol="4,3,2,2" class="ageing-bucket-label">
                          <span class="ageing-dot ageing-warn"></span> 30 – 60 days
                        </div>
                        <div nxCol="4,3,2,2" class="ageing-count ageing-warn">
                          {{ stats.ageing?.thirtyToSixty ?? 0 }}
                        </div>
                        <div nxCol="4,6,8,8" class="ageing-bar-wrap">
                          <div class="ageing-bar ageing-bar-warn"
                            [style.width.%]="stats.totalInvoices > 0 ? ((stats.ageing?.thirtyToSixty ?? 0) / stats.totalInvoices * 100) : 0">
                          </div>
                        </div>
                      </div>

                      <!-- 60–90 days -->
                      <div nxRow>
                        <div nxCol="4,3,2,2" class="ageing-bucket-label">
                          <span class="ageing-dot ageing-alert"></span> 60 – 90 days
                        </div>
                        <div nxCol="4,3,2,2" class="ageing-count ageing-alert">
                          {{ stats.ageing?.sixtyToNinety ?? 0 }}
                        </div>
                        <div nxCol="4,6,8,8" class="ageing-bar-wrap">
                          <div class="ageing-bar ageing-bar-alert"
                            [style.width.%]="stats.totalInvoices > 0 ? ((stats.ageing?.sixtyToNinety ?? 0) / stats.totalInvoices * 100) : 0">
                          </div>
                        </div>
                      </div>

                      <!-- 90–120 days -->
                      <div nxRow>
                        <div nxCol="4,3,2,2" class="ageing-bucket-label">
                          <span class="ageing-dot ageing-critical"></span> 90 – 120 days
                        </div>
                        <div nxCol="4,3,2,2" class="ageing-count ageing-critical">
                          {{ stats.ageing?.ninetyToOneTwenty ?? 0 }}
                        </div>
                        <div nxCol="4,6,8,8" class="ageing-bar-wrap">
                          <div class="ageing-bar ageing-bar-critical"
                            [style.width.%]="stats.totalInvoices > 0 ? ((stats.ageing?.ninetyToOneTwenty ?? 0) / stats.totalInvoices * 100) : 0">
                          </div>
                        </div>
                      </div>

                      <!-- > 120 days -->
                      <div nxRow>
                        <div nxCol="4,3,2,2" class="ageing-bucket-label">
                          <span class="ageing-dot ageing-critical"></span> &gt; 120 days
                        </div>
                        <div nxCol="4,3,2,2" class="ageing-count ageing-critical">
                          {{ stats.ageing?.overOneTwenty ?? 0 }}
                        </div>
                        <div nxCol="4,6,8,8" class="ageing-bar-wrap">
                          <div class="ageing-bar ageing-bar-critical"
                            [style.width.%]="stats.totalInvoices > 0 ? ((stats.ageing?.overOneTwenty ?? 0) / stats.totalInvoices * 100) : 0">
                          </div>
                        </div>
                      </div>

                    </div>
                  </nx-card>
                </div>
              </div>

              <!-- TOP DEALERS TABLE (admin only) -->
              <div nxRow class="nx-margin-bottom-m" *ngIf="isAdminView && stats.topDealers?.length > 0">
                <div nxCol="12">
                  <nx-card class="chart-card">
                    <h3 nxHeadline="subsection-small" class="nx-font-weight-semibold chart-title nx-margin-bottom-s">
                      Dealers with Pending / Under Process Invoices
                    </h3>
                    <table nxTable zebra condensed>
                      <thead>
                        <tr nxTableRow>
                          <th nxHeaderCell>Dealer Name</th>
                          <th nxHeaderCell>Dealer Code</th>
                          <th nxHeaderCell style="text-align:center">Open Invoices</th>
                          <th nxHeaderCell style="text-align:center">Oldest (Days)</th>
                          <th nxHeaderCell style="text-align:right">Claimed Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr nxTableRow *ngFor="let dealer of stats.topDealers">
                          <td nxTableCell>{{ dealer.dealerName }}</td>
                          <td nxTableCell>{{ dealer.dealerCode }}</td>
                          <td nxTableCell style="text-align:center">{{ dealer.openCount }}</td>
                          <td nxTableCell style="text-align:center">
                            <nx-badge [type]="dealer.oldestDays > 30 ? 'critical' : dealer.oldestDays > 15 ? 'active' : 'positive'">
                              {{ dealer.oldestDays }} days
                            </nx-badge>
                          </td>
                          <td nxTableCell style="text-align:right">
                            {{ dealer.claimedAmount | currency:'INR':'symbol':'1.0-0' }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </nx-card>
                </div>
              </div>

            </ng-container>
          </div>
        </nx-tab>

      </nx-tab-group>
    </div>
  </div>

</div>

<app-footer></app-footer>
